import React from "react"
import './life.css'

const img_list = [
    'https://cdn.img.tyhjrbl.com/img/202604/02/115394bjXRQHLy.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1148RGfY7aUyS4.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1148KfLqR2Jdr5.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1148xXiy2DJHmv.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1148LMT1yeKufi.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1148luKhIGlH0c.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149rQ3byUtNQX.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149vKZoUrUgYp.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149s1sVMoVoL8.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149hsaDJ9mCKC.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149xFx9qytQRQ.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149Q4m4wFaVOA.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149ew9gkHIk2c.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/11498Yg5aj2cSr.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149TvSla1D9qb.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149A55Jfkv81K.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149XxjsFR2gqF.png',
    'https://cdn.img.tyhjrbl.com/img/202604/02/1149OORc1tZxUh.png',
]


export default function Life () {
    return (
        <>
            <div className='life_box'>
                <div className='one'>
                    {img_list.slice(0, 4).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                </div>
                <div className='two'>
                    {img_list.slice(4, 8).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                </div>
                <div className='three'>
                    {img_list.slice(8, 12).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                </div>
                <div className='four'>
                    {img_list.slice(12 , 15).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
                <div className='five'>
                    {img_list.slice(15 , 18).map((value, index) => {
                        return (
                            <div key={index}>
                                <img src={value} alt="" />
                            </div>
                    )})}
                    <div></div>
                </div>
            </div>
        </>
    )
}